// extracted by mini-css-extract-plugin
module.exports = {"menuItems":"menuFoods_menuItems__3vgBG","emptyDialog":"menuFoods_emptyDialog__1HDZP","costBox":"menuFoods_costBox__SI0fB","searchBar":"menuFoods_searchBar__1RjsA"};